import { schemaEuropaceAntrag_Export, schemaEuropacePartnerId, schemaVorgangsnummer } from 'cpool-schemas';
import { z } from 'zod';

import { censorEuropaceAntrag, censorEuropaceAntragApplicant2Only } from '../../../../../utils/censor.utils';
import type { EventSchema } from '../../../../../utils/EventSchema';
import { _Event } from '../../../../_Event';

export class LoanRequest_EuropaceOffersSyncNewOfferFound extends _Event {
    getSchema() {
        return z.object({
            newOffer: schemaEuropaceAntrag_Export,
            offerId: z.string().uuid(),
            partnerId: schemaEuropacePartnerId,
            processId: schemaVorgangsnummer,
        });
    }

    getCensoredSchema() {
        return this.getSchema().transform((data) => {
            return {
                ...data,
                newOffer: censorEuropaceAntrag(data.newOffer),
            };
        });
    }

    getCensoredSchemaApplicant2Only(_applicant2Id: string) {
        return this.getSchema().transform((data) => ({
            ...data,
            newOffer: censorEuropaceAntragApplicant2Only(data.newOffer),
        }));
    }

    static example() {
        return {
            newOffer: {
                antragsnummer: 'KR3DI7/1/1',
            },
            offerId: '22097497-e7b6-402a-a65b-6c02c049d067',
            partnerId: 'ABC12',
            processId: 'KR3DI7',
        } satisfies EventSchema<LoanRequest_EuropaceOffersSyncNewOfferFound>;
    }

    static exampleCensoredApplicant2Only() {
        const example = LoanRequest_EuropaceOffersSyncNewOfferFound.example();
        return {
            ...example,
            newOffer: censorEuropaceAntragApplicant2Only(example.newOffer),
        };
    }

    static exampleCensored() {
        const example = LoanRequest_EuropaceOffersSyncNewOfferFound.example();
        return {
            ...example,
            newOffer: censorEuropaceAntrag(example.newOffer),
        };
    }
}
